<template>
  <v-row
    v-if="value.title || value.paragraph"
    :class="dense ? '' : 'mb-6'"
    justify="center"
  >
    <v-col class="text-center" cols="12" md="8">
      <TitleParagraphBlock :value="value" />
    </v-col>
  </v-row>
</template>

<script setup>
defineProps({
  dense: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
